import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getAllSongs, createSong, updateSong, deleteSong} from "./API";

export const getSongsThunk = createAsyncThunk(
    'songs/getSongs',
    async (spaceId) => {
        return getAllSongs(spaceId)
    }
)

export const createSongThunk = createAsyncThunk(
    'songs/createSong',
    async (payload) => {
        return createSong(payload.spaceId, payload.data)
    }
)

export const updateSongThunk = createAsyncThunk(
    'songs/updateSong',
    async (payload) => {
        return updateSong(payload.spaceId, payload.songId, payload.data)
    }
)

export const deleteSongThunk = createAsyncThunk(
    'songs/deleteSong',
    async (payload) => {
        await deleteSong(payload.spaceId, payload.songId)
    }
)

const SongsSlice = createSlice({
    name: 'songs',
    initialState: {songs: [], status: 'idle', error: null},
    reducers: {},
    extraReducers: {
        [getSongsThunk.pending]: (state) => {
            state.status = 'loading'
        },
        [getSongsThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [getSongsThunk.fulfilled]: (state, action) => {
            state.songs = Array.isArray(action.payload) ? action.payload : []
            state.status = 'idle'
        },
        [createSongThunk.pending]: (state) => {
            state.status = 'loading'
        },
        [createSongThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [createSongThunk.fulfilled]: (state, action) => {
            state.status = 'idle'
        },
        [updateSongThunk.pending]: (state) => {
            state.status = 'loading'
        },
        [updateSongThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [updateSongThunk.fulfilled]: (state, action) => {
            state.status = 'idle'
        },
        [deleteSongThunk.pending]: (state) => {
            state.status = 'loading'
        },
        [deleteSongThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [deleteSongThunk.fulfilled]: (state, action) => {
            state.status = 'idle'
        }
    }
})

export default SongsSlice.reducer
